

export default function OrderConfirmed() {
  return (
    <>
    <div className="h-screen overflow-auto flex bg-white">
     <div className="w-full m-auto">
        <div className="max-w-[600px] mx-auto p-5">
            <img src="/assets/img/confirmed.png" className="w-[200px] object-conatin mx-auto"/>
            <div className="space-y-2 mt-8">
          <h2 className="text-xl font-semibold text-[#15AF05] text-center">Order Confirmed</h2>
          <h3 className="text-sm text-[#464646] text-semibold text-center">Your payment was successful.</h3>
                    <p className="text-sm text-[#777777]">
            Thank you for your purchase! Your order has been received and is now being processed.
          </p>
          </div>
          <div className="mt-6">
          <h3 className="text-sm font-semibold text-[#464646]">Details:</h3>
          <ul className="text-sm pl-[24px]">
            <li className="text-[#505050] list-disc"> Order ID: <span className="text-[#777777]">#123456</span> </li>
            <li className="text-[#505050] list-disc"> Payment Status: <span className="text-[#777777]">Paid</span> </li>
            <li className="text-[#505050] list-disc"> Date: <span className="text-[#777777]">10 Apr 2026</span> </li>
          </ul>
        </div>
        <div className="flex items-center justify-center flex-wrap gap-4 mt-8">
          <button className="bg-[linear-gradient(45deg,#115B9D,#116DAE)] text-sm font-[600] text-gray-600 border rounded-full shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed p-[2px]">
            <span className="flex items-center justify-center gap-2 rounded-full bg-white h-10 hover:opacity-80 !px-8">Continue Shopping</span>
          </button>
          <button className="bg-[linear-gradient(45deg,#115B9D,#116DAE)] text-sm font-[600] text-white h-11 flex items-center justify-center gap-2 rounded-full shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed !px-8">
           View Order
          </button>
        </div>
        </div>
     </div>
    </div>
    </>
  )
}
